import React, { useState, useEffect } from 'react';


const Tabs = ({ options, onSelect,customStyle, collapsed }) => {
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const handleSelect = (option) => {
    setSelectedOption(option);
    onSelect(option);
  };


  return (
    <div className="tabs-container transition-all duration-300 ease-in-out">
      <div className="w-full font-medium text-center text-black-80 z-50 ${customStyle && customStyle}">
        <ul className={`flex items-center justify-around text-nowrap gap-1  ${collapsed ? "p-0" : "p-1 md:p-1"}`}>
          {options?.length > 0 && options.map((tabItem) => (
            <button className={`${collapsed && selectedOption.label !== tabItem.label ? "hidden" : "flex"} w-full z-50 flex flex-col md:flex-row p-3 sm:px-4 items-center rounded-xl  md:rounded-xl bg-white-light sm:bg-transparent md:bg-white-light justify-center gap-2 text-xs sm:text-sm cursor-pointer transition-all duration-300 ease-in-out 
                ${selectedOption.label === tabItem.label ? ` ${customStyle ? "border-none" : "sm:border-blue-95"} border border-blue-95 bg-blue-gradient sm:bg-transparent md:bg-blue-gradient ${customStyle ? "text-white-default !font-bold" : "text-blue-95 font-bold" }   md:border-blue-95 font-bold` :
                   'border border-black-2 font-medium bg-white-light  md:bg-white-light shadow-black-8'} ${tabItem.isDisabled ? "pointer-events-none text-gray-500" :`${customStyle ? "text-white-70 font-medium" : "text-black-60" } `}  `}
              key={tabItem?.label}
              onClick={() => handleSelect(tabItem)}>
                {tabItem?.icon && (selectedOption.label === tabItem.label ? <img className='h-5 w-5' src={tabItem.activeIcon} alt={tabItem?.label}/> : <img className='h-5 w-5' src={tabItem.icon} alt={tabItem?.label}/>)}
                {!collapsed && <span className={`${selectedOption.label === tabItem.label ? "text-blue-95" : "text-black-80"}`}>{tabItem?.label}</span>}
              {tabItem?.showItemsLength && <span className={`max-sm:hidden rounded-full text-sm ${selectedOption.label === tabItem.label ? "bg-blue-15 text-blue-95" :"bg-black-80 text-white-default"} px-2`}>{tabItem.totalItem}</span> }
            </button>
          ))}
                 </ul>
      </div>
    </div>

  )
};


export default Tabs